import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';
import {FilePdfTwoTone} from '@ant-design/icons';

const {Text, Paragraph} = Typography;
const Content = Layout;

const CuatroPD = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Clinical Trials</Paragraph>
        <Text className='BaseText2' style={{marginTop: '0%'}}>iMoAge will always endeavor to keep the client informed about the study procedures, including the risks and benefits of participating in this study. Therefore, we cover different points:</Text>
        <Text className='BaseText2' style={{marginTop: '2%'}}>
          <ul>
            <li><b>Brief Summary</b></li>
            <li><b>Consent</b></li>
            <li><b>Introduction</b></li>
            <li><b>Purpose</b></li>
            <li><b>Procedure</b></li>
            <li><b>Participation</b></li>
            <li><b>Risks</b></li>
            <li><b>Benefits</b></li>
            <li><b>Privacy</b></li>
          </ul>
        </Text>
        <Text className='BaseText' style={{marginTop: '3%', textAlign: 'center'}}><i>In the following PDF you can find the entire clinical study.</i></Text>
        <Content style={{width: '100%', marginTop: '1%', background: 'transparent', textAlign: 'right'}}>
          <a style={{width: 'fit-content', marginLeft: 'auto', marginRight: '50px', marginBottom: '5px'}} target='_blank' rel='noopener noreferrer' href='https://static.igem.wiki/teams/4464/wiki/emprendimiento/clinical-trial.pdf'><FilePdfTwoTone style={{fontSize: '8vh'}} twoToneColor='#eb2f96'/></a>
          <p style={{textAlign: 'right'}}><i>Download Here</i></p>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default CuatroPD;
